module.exports = __webpack_public_path__ + "files/ae30ea223cf1ff103be0644d855e486e.png";